import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import * as React from 'react';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    height: '100%',
    '& div:first-child': {
      borderRadius: '8px 8px 0 0',
    },
  },
};

const GridRootBase = ({ children, classes, className, ...props }) => (
  <div className={clsx(classes.root, className)} {...props}>
    {children}
  </div>
);

GridRootBase.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

GridRootBase.defaultProps = {
  className: undefined,
};

export const GridRoot = withStyles(styles)(GridRootBase);
